export default {
  common: {
    loading: "Loading...",
  },
  header: {
    openMenu: "Open menu",
    home: "Home",
    language: "Language",
    searchPlaceholder: "Search a page...",
    searchLabel: "Search a page",
    noResult: "No results found",
    notifications: "Notifications",
    notificationsUnread: "Notifications, {count} unread",
    markAllRead: "Mark all as read",
    onlyUnread: "Unread only",
    loadMore: "Load more",
    viewAllNotifications: "View all notifications",
    noNotifications: "No notifications",
    onlineAccount: "Account online",
    myAccount: "My account",
    myProfile: "My profile",
    profile: "Profile",
    settings: "Settings",
    logout: "Log out",
    roleAdmin: "Admin",
    roleClient: "Client",
    roleDriver: "Driver",
    roleZoneManager: "Zone manager",
    justNow: "Just now",
    minutesAgo: "{n} min ago",
    hoursAgo: "{n} h ago",
  },
  theme: {
    enableLight: "Switch to light mode",
    enableDark: "Switch to dark mode",
    light: "Light mode",
    dark: "Dark mode",
  },
  sidebar: {
    mainNav: "Main navigation",
    mainMenu: "Main menu",
    closeMenu: "Close menu",
    loadingMenu: "Loading menu",
  },
  menu: {
    dashboard: "Dashboard",
    trackingDrivers: "Driver locations",
    parcels: "Parcels",
    parcelsList: "Parcel list",
    newParcels: "New parcels list",
    addParcel: "New parcel",
    inventory: "Inventory",
    productsList: "Product list",
    stockParcels: "Stock parcels",
    deliveryNotes: "Delivery notes",
    deliveryStockNotes: "Stock delivery notes",
    packingStation: "Preparation & packing",
    parcelReception: "Parcel reception",
    sentNotes: "Dispatch notes",
    distributionNotes: "Distribution notes",
    driverCheck: "Driver follow-up",
    driverInvoices: "Driver invoices",
    zoneInvoices: "Zone invoices",
    returnNotes: "Return notes",
    zoneReturns: "Zone returns",
    clientReturns: "Client returns",
    clientInvoices: "Client invoices",
    invoicesList: "Invoice list",
    newInvoice: "New invoice",
    transfers: "Bank transfers",
    refunds: "Refunds",
    customers: "Clients",
    customersList: "Client list",
    newCustomers: "New clients",
    verificationCenter: "Verification center",
    ribRequests: "RIB requests",
    phoneRequests: "Phone requests",
    claims: "Claims",
    exchanges: "Exchange",
    driverReturnsFollowup: "Driver returns follow-up",
    parcelFollowups: "Parcels to follow up",
    pickup: "Pickup",
    pickupNotes: "Pickup notes",
    pickupRequests: "Pickup requests",
    users: "Users",
    usersList: "User list",
    newDrivers: "New drivers",
    driversStatus: "Driver status",
    expenses: "Expenses",
    carrierInvoices: "Carrier invoices",
    transport: "Transport",
    transportsList: "Carriers",
    settings: "Settings",
    profile: "Profile",
    general: "General",
    zones: "Zones",
    pricePacks: "Price packs",
    cities: "Cities",
    agencies: "Agencies",
    whatsapp: "WhatsApp",
    ads: "Announcements",
    blackList: "Blacklist",
  },
  pages: {
    addCustomer: "Add client",
    addUser: "Add user",
    pendingDrivers: "Pending drivers",
    pickups: "Pickups",
    receptionNotes: "Reception notes",
    driverPaymentNotes: "Driver payment notes",
    zonePaymentNotes: "Zone payment notes",
    invoices: "Invoices",
    stockProducts: "Stock products",
    verifications: "Verifications",
    accountSettings: "Account settings",
    statuses: "Statuses",
    clientTypes: "Client types",
    banks: "Banks",
    transports: "Carriers",
    trackingDrivers: "Driver locations",
    refundRequests: "Refund requests",
    pointageNotes: "Attendance notes",
    addPointage: "Add attendance note",
    externDeliveryNotes: "External delivery notes",
    deliveryProviders: "Delivery providers",
    socialLinks: "Social links",
    driverApiDocs: "Driver API documentation",
    addProduct: "Add product",
    addDeliveryStockNote: "Add stock delivery note",
    addReceptionNote: "Add reception note",
    addSentNote: "Add sent note",
    addGlobalSentNote: "Add global sent note",
    addDistributionNote: "Add distribution note",
    addDriverPayment: "Add driver payment note",
    addZonePayment: "Add zone payment note",
    addClientReturn: "Add client return note",
    addZoneReturn: "Add zone return note",
    addInvoice: "Add invoice",
    addVirement: "Add transfer",
    addExpense: "Add expense",
  },
};
